var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "42px",
    height: "34px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "42px",
    height: "34px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAiBAMAAADbvlYFAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAElBMVEWKrsaKrsZWbHs0QksAAAD///9gLLsXAAAABHRSTlMAWKPTS8x11gAAAAFiS0dEBfhv6ccAAAAHdElNRQfoAhQTCQxVbEqsAAAAbElEQVQoz82S0QnAMAgFzQa1uEGzQEeQuP9M1aSBaPIZaN9P4Dh4KgGAdB0w55R7hilLURktoyomkz48qmKyp6aa7GmutASKSMLaE9rU4nmyTyj2OErSwpvpuu1Xd3in81v0TXbRdVuM/zM1D2kTNQDHaFxoAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort1);
export default __webpack_public_path__ + "static/media/sort-1.93459d841d2fd919ebd1b5ec9eefda5b.svg";
export { ForwardRef as ReactComponent };